import setUserByLocal from "./setUserByLocal";
import userSlice from "@/redux/services/userSlice";
import store from "@/redux/store"
export default (user) => {
    setUserByLocal(user);
    store.dispatch(userSlice.actions.set(user));
}
